import * as React from "react";
import classnames from "classnames";
import Styles from "./Styles.module.scss";

declare type Directions = "row" | "column";
declare type ViewTypes = "flex" | "grid";
declare type StyleTypes = React.CSSProperties | Array<React.CSSProperties>;

declare interface ViewProps {
    id?: string;
    className?: string;
    style?: StyleTypes;
    direction?: Directions;
    ref?: React.RefObject<HTMLDivElement>;
    wrap?: boolean;
    type?: ViewTypes;
    gridArea?: string;
    onClick?:
        | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
        | undefined;
}

//@ts-ignore
const View: React.FC<ViewProps> = React.forwardRef<HTMLDivElement, ViewProps>(
    (props, ref) => {
        const {
            className,
            style,
            children,
            direction,
            id,
            wrap,
            type,
            gridArea,
            onClick,
        } = props;

        const _style =
            type === "flex"
                ? {
                      display: "flex",
                      flexDirection: direction,
                      flexWrap: (wrap ? "wrap" : "nowrap") as any,
                      cursor: onClick ? "pointer" : "default",
                  }
                : {
                      display: "grid",
                      cursor: onClick ? "pointer" : "default",
                  };

        let finalStyle = _style;

        if (Array.isArray(style)) {
            style.forEach((element) => {
                finalStyle = Object.assign(finalStyle, element);
            });
        } else {
            finalStyle = Object.assign(finalStyle, style);
        }

        if (gridArea) {
            finalStyle = Object.assign(finalStyle, { gridArea });
        }

        return (
            <div
                id={id}
                ref={ref}
                className={classnames(
                    type === "grid" ? Styles.gridStyle : "",
                    className
                )}
                style={finalStyle}
                onClick={onClick}
            >
                {children}
            </div>
        );
    }
);

View.defaultProps = {
    id: "",
    className: "",
    style: {},
    direction: "column",
    type: "flex",
};

export default View;
